export class RequestFormWrapper {
    constructor() {
        const requestBtn = document.querySelector('.request-btn');
        const form = document.querySelector('.request-form_wrapper');
        
        requestBtn.querySelector('.wp-block-button__link').addEventListener('click', (event) => {
            event.preventDefault();
            form.classList.add('show-form');
            requestBtn.parentElement.style.display = 'none';

            setTimeout(() => {
                form.querySelector('input:first-of-type').focus();
                form.classList.add('slide--in');
            }, 50);
        });
    }
}